import WMTS, {optionsFromCapabilities} from 'ol/source/WMTS';
import {WMTSCapabilities, WMSCapabilities} from 'ol/format';
import TileWMS from 'ol/source/TileWMS';
import Collection from 'ol/Collection';
import {Tile as TileLayer} from 'ol/layer';

const parserWMTS = new WMTSCapabilities();
const parserWMS = new WMSCapabilities();

async function getLayerFromCapabilitiesWMTS(props, visible) {
  const responses = await getOptionsFromCapabilities(props);
  if (responses) {
    const tileLayers = responses.map((response) => {
      const source = new WMTS(response);
      return new TileLayer({
        ...props,
        source,
        visible,
        properties: {
          ...props,
          name: response.params.Title,
        },
      });
    });
    return new Collection(tileLayers.filter((tileLayer) => tileLayer));
  }
  return null;
}

async function getLayerFromCapabilitiesWMS(props, visible) {
  const responses = await getOptionsFromCapabilities(props);

  if (responses) {
    const tileLayers = responses.map(({url, params}) => {
      const source = new TileWMS({
        url,
        params: {
          LAYERS: params.Name,
        },
      });
      return new TileLayer({
        ...props,
        source,
        visible,
        properties: {
          ...params,
          name: params.Title,
        },
      });
    });
    return new Collection(tileLayers.filter((tileLayer) => tileLayer));
  }
  return null;
}

function getOptionsFromCapabilities({url, format, matrixSet = 'EPSG:25830'}) {
  return new Promise((resolve) => {
    fetch(url.toLowerCase())
      .then(function(response) {
        return response.text();
      })
      .then(function(text) {
        if (format.toLowerCase() === 'wmts') {
          const result = parserWMTS.read(text);
          const options = result.Contents.Layer.map((item) => {
            const option = optionsFromCapabilities(result, {
              layer: item.Identifier,
              matrixSet,
            });
            option.params = item;
            return option;
          });
          resolve(options);
        } else if (format.toLowerCase() === 'wms') {
          const result = parserWMS.read(text);
          const options = result.Capability.Layer.Layer.map((item) => {
            return {
              url: result.Capability.Request.GetMap.DCPType[0].HTTP.Get.OnlineResource,
              params: item,
            };
          });
          resolve(options);
        }
      })
      .catch(() => {
        resolve(null);
      });
  });
}

export default async (obj, visible = false) => {
  if (obj?.format?.toLowerCase() === 'wmts') {
    return await getLayerFromCapabilitiesWMTS(obj, visible);
  } else if (obj?.format?.toLowerCase() === 'wms') {
    return await getLayerFromCapabilitiesWMS(obj, visible);
  }
};
